import '../modules/slider-recommend';
import '../modules/slider-mobile-swipe';
import '../modules/tabs';
import 'magnific-popup';
import '../modules/select';
import '../modules/jquery.zoom';

// Slideshow
$('.js-item-slide').on('click', function() {
  $('.item-card-img__picture').trigger('zoom.destroy');

  const src = $(this).find('img').attr('src');

  $(this).closest('.js-slideshow').find('.btn-item-slide').removeClass('active');
  $(this).addClass('active');
  $('.js-slideshow-image').attr('src', src);
  $('.js-slideshow-image').attr('data-zoom', src);

  $('.item-card-img__picture').zoom();
});

// Popup gallery
$('.js-popup-image').on('click', function() {
  const items = [];

  $('.js-item-slide').find('img').each(function() {
    if ($(this).parent().hasClass('active')) {
      items.unshift({
        src: $(this).attr('src')
      });
    } else {
      items.push({
        src: $(this).attr('src')
      });
    }
  });

  $.magnificPopup.open({
    items: items,
    type: 'image',
    gallery: {
      enabled: true
    }
  });
});

//  Magnific popip init inline
if ($('.js-popup-inline').length) {
  $('.js-popup-inline').magnificPopup({
    type: 'inline',
    midClick: true
  });
}

$('.item-card-img__picture').zoom();
